<div class="main-content">
    <div class="container-fluid">
        <div class="card">
    
            <div class="card-header card-header-squirrel">
                <!-- <h4 class="card-title">{{this.translate.data['CONFIRMUSER'] | translate}}</h4> -->
                <!-- <h4 class="card-title">Confirm User {{user.email}}</h4> -->
                <h4 class="card-title">Benutzer {{userName}}</h4>
            </div>
        
            <div class="row">
                <span style="flex: 1 1 auto"></span>
                <button style="margin-right: 20px; margin-top: 20px" matTooltip="Weiter zu den Projekten" mat-button (click)="continue()" [disabled]="!isConfirmed">
                    <h5>Weiter</h5>
                </button>
            </div>

        
            <!-- <mat-expansion-panel class="navbar-transparent" [expanded]="tenantVisible" (opened)="tenantVisible=true" (closed)="tenantVisible=false"> -->
            
            <!-- <mat-expansion-panel class="navbar-transparent" [expanded]="expandData" (opened)="expandData=true" (closed)="expandData=false"> -->
                <!-- <mat-expansion-panel-header>
                    <mat-panel-title>
                        <h4 class="card-title">Allgemeine Benutzerdaten</h4>
                        <span style="color: red; margin-left: 15px;" *ngIf="!user.emailConfirmed">noch unbestätigt!</span>
                        <span style="color: darkgreen; margin-left: 15px;" *ngIf="user.emailConfirmed">bestätigt!</span>
                    </mat-panel-title>
                </mat-expansion-panel-header> -->
            <mat-card class="navbar-transparent" >
                <div class="navbar-transparent">
                    <mat-panel-title>
                        <h4 class="card-title">Allgemeine Benutzerdaten</h4>
                        <span style="color: red; margin-left: 15px;" *ngIf="!user.emailConfirmed">noch unbestätigt!</span>
                        <span style="color: darkgreen; margin-left: 15px;" *ngIf="user.emailConfirmed">bestätigt!</span>
                    </mat-panel-title>
                </div>
                <div class="panelContent">
                    <form [formGroup]="userMainForm" novalidate>
                    
                        <div class="row">
                        <!-- <div class="col-md-4">
                            <mat-form-field class="example-full-width">
                            <input type="text" matInput placeholder="Benutzer" formControlName="userName" required>
                            <mat-error *ngIf="!userMainForm.controls['userName'].valid && userMainForm.controls['userName'].touched"> {{this.translate.data['ERRORALERT'] | translate}} </mat-error>
                            </mat-form-field>
                        </div> -->
                        <div class="col-md-4">
                            <mat-form-field class="example-full-width">
                                <input matInput placeholder="E-Mail" formControlName="email" disabled="disabled">
                            </mat-form-field>
                        </div>  
                    </div>            
                
                    <div class="row">
                        <div class="col-md-4">
                            <mat-form-field class="example-full-width">
                                <input matInput placeholder="Vorname" formControlName="firstName" >
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field class="example-full-width">
                                <input matInput placeholder="Nachname" formControlName="lastName" >
                            </mat-form-field>
                        </div>
                    </div>  

                    <div class="row">
                        <div class="col-md-4">
                            <mat-form-field class="example-full-width">
                                <input matInput placeholder="Tel. Nr." formControlName="phoneNumber" >
                            <!-- <mat-error *ngIf="!projectCreationForm.controls['latitude'].valid && projectCreationForm.controls['latitude'].touched"> {{
                                this.translate.data['ERRORALERT'] | translate}}  </mat-error> -->
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <!-- <button matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}" mat-button (click)="cancel()" >
                            <mat-icon>close</mat-icon>
                        </button> -->
                        <span style="flex: 1 1 auto"></span>
                        <!-- <span style="color: red" *ngIf="!user.emailConfirmed">noch unbestätigt!</span>
                        <span style="color: darkgreen" *ngIf="user.emailConfirmed">bestätigt!</span> -->
                        <button matTooltip="Daten bestätigen" mat-button (click)="confirm()">
                            <!-- <mat-icon>add</mat-icon> -->
                            <h5>Bestätigen</h5>
                        </button>
                    </div>    
                    </form>
                </div>
            </mat-card>

            <!-- <div class=""row> -->
                <section *ngFor="let userTenant of userTenants">
                    <confirm-tenant-user [userTenant] = "userTenant" [baseUser] = "user" [stayExpanded] = "userTenant.isExpanded" (onChangeTenantUser)="onChange(user)"></confirm-tenant-user>
                </section>
            <!-- </div> -->

            <div class="row">
                <span style="flex: 1 1 auto"></span>
            <button style="margin-right: 20px" matTooltip="Weiter zu den Projekten" mat-button (click)="continue()" [disabled]="!isConfirmed">
                <!-- <mat-icon>add</mat-icon> -->
                <h5>Weiter</h5>
                </button>
            </div>
        </div>
    </div>
</div>

  
